module.exports = {
      id: "success-circle-usage",
      viewBox: "0 0 89 88",
      url: __webpack_public_path__ + "svg-sprite-8e03654a4a2895e52544254db36238f1.svg#success-circle",
      toString: function () {
        return this.url;
      }
    }